exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Progress_wrap_3mx2 {\n  width: 100%;\n}\n\n.Progress_progress_1VkR {\n  position: relative;\n\n  height: 12px;\n\n  border-radius: 10px;\n  background-color: #e2e2e2;\n}\n\n.Progress_progress__line_3Dyj {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n\n  height: inherit;\n\n  border-radius: 10px;\n\n  -webkit-transition: width 0.4s ease-in-out, background-color 0.15s ease-out;\n\n  transition: width 0.4s ease-in-out, background-color 0.15s ease-out;\n}\n", ""]);

// exports
exports.locals = {
	"wrap": "Progress_wrap_3mx2",
	"progress": "Progress_progress_1VkR",
	"progress__line": "Progress_progress__line_3Dyj"
};